// Author Shi Wenlong
// Date 2021-12-20 15:18:19

import * as model from "@/model/sithMes/stool/SithMesStoolGrnModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolGrn(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
        callbackApi: process.env.VUE_APP_SITHMES_STOOL_URL + '/sithMesStoolGrn/workflow/complete-feedback',
        processDefinitionKey: "sith_mes_stool_grn",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
